// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 2228) return "static/chunks/2228.077997f35cab15cb.js";
	if (chunkId === 832) return "static/chunks/832.48c907cc3a5d2408.js";
	if (chunkId === 6200) return "static/chunks/6200.bccd7ae7ecce3cb4.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"3380":"479ba886","8087":"0e762574"}[chunkId] || chunkId) + "-" + {"1526":"80a621d43d6df676","2354":"4fc77e5623d35886","3380":"e4bfafd61cc88166","4713":"96db43bf29ce1dfc","5751":"36b41c0ea8c1b27a","6671":"3c29e9f8010050dd","7709":"0af48590b387f700","8087":"b591e439b3ab5895","9352":"0f540fd5108c69ca"}[chunkId] + ".js";
};